import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    clearModalState,
    closeModal,
    setModalData,
} from "../../../../redux/slices/modal/modal.slice";
import CreateMetaCustomAudience from "./CreateMetaCustomAudience.layout";

const mapStateToProps = (state: any) => ({});
const mapDispatchToProps = (dispatch: any) => ({
    dispatchCloseModal: () => dispatch(closeModal()),
    dispatchSetModalData: (payload: any) => dispatch(setModalData(payload)),
    dispatchClearModalState: () => dispatch(clearModalState()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(CreateMetaCustomAudience);
